export class Passwords {
  password = 'Strong#2@pass';
}
